const ANCHOR_ELEMENT_SELECTOR = {
  DELIVERY: '#multi-checkout__delivery',
  DESTINATION: '#multi-checkout__destination',
  SUMMARY: '.order-summary',
};

const ELEMENT_SEQUENCE = [
  ANCHOR_ELEMENT_SELECTOR.DELIVERY,
  ANCHOR_ELEMENT_SELECTOR.DESTINATION,
  ANCHOR_ELEMENT_SELECTOR.SUMMARY,
];

const getSectionSpacing = () => {
  const sectionMarginBottom = $(
    `${ANCHOR_ELEMENT_SELECTOR.DELIVERY} .collapse-section`,
  ).css('margin-bottom');
  return parseInt(sectionMarginBottom, 10) || 0;
};

export const CART_SECTION = {
  DELIVERY: 0,
  DESTINATION: 1,
  SUMMARY: 2,
};

// utils functions
export function scrollTop(yPosition = 0) {
  const NAV_HEIGHT = $('nav:visible').outerHeight() || 0;
  window.scrollTo({
    top: yPosition - NAV_HEIGHT,
    behavior: 'smooth',
  });
}

export function scrollToSection(sectionIndex, options = {}) {
  if (options.scrollDirectly) {
    scrollTop($(ELEMENT_SEQUENCE[sectionIndex]).offset()?.top);
    return;
  }
  const anchorElementSelectors = ELEMENT_SEQUENCE.slice(0, sectionIndex);
  const yPosition = anchorElementSelectors.reduce(
    (sum, anchorElementSelector, index) => {
      const anchorElement = $(
        `${anchorElementSelector} .collapse-section__header:visible`,
      );

      if (anchorElement.length === 0) {
        return sum;
      }

      return index === 0
        ? sum + anchorElement.offset()?.top + anchorElement.outerHeight()
        : sum + anchorElement.outerHeight() + getSectionSpacing();
    },
    0,
  );
  scrollTop(yPosition);
}
